import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { ContentShareWidget } from "~/components/content/content-share-widget";
import { ZIndexLayer } from "~/lib/styles";

export const Container = styled.aside`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: min-content;
`;

export type ContentShareWidgetProps = {
  $direction: "column" | "row";
  $outlineColor?: string;
};
export const StyledContentShareWidget = styled(ContentShareWidget, {
  ...transientOptions,
})<ContentShareWidgetProps>`
  position: relative;

  display: flex;
  flex-flow: ${props => props.$direction};
  gap: 16px;
  justify-content: flex-start;
  align-items: center;

  ${props =>
    props.$outlineColor &&
    css`
      button > * {
        border: 1px solid ${props.$outlineColor};
      }
    `}

  > [role="tooltip"] {
    z-index: ${ZIndexLayer.AppBar - 1};
  }
`;
